import { ArrowsChevronDown } from "@fanduel/formation-react-icons";
import { fanduel as fd } from "@fanduel/formation-tokens";
import { Loader } from "@fanduel/og-fe-library";
import { RACING_SHOW_MORE_CLICKED } from "@/constants/amplitude";
import { Hr_Race } from "@/graphql/gql/graphql";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import ConsensusInfo from "../raceInfo/ConsensusInfo";
import RaceInfo from "../raceInfo/RaceInfo";
import styles from "./raceList.module.scss";

interface RaceListProps {
  races: Hr_Race[];
  loading: boolean;
  isConsensus?: boolean;
  fetchNextPage: () => void;
}

const RaceList = ({
  races,
  loading,
  fetchNextPage,
  isConsensus,
}: RaceListProps) => {
  const { logAmplitudeEvent } = useAmplitude();
  return (
    <div data-testid="horseRacing list" className={styles.container}>
      {races?.map((race) =>
        isConsensus ? (
          <ConsensusInfo
            key={`${race.number} + ${race.track?.code}`}
            race={race}
          />
        ) : (
          <RaceInfo key={`${race.number} + ${race.track?.code}`} race={race} />
        )
      )}
      {loading ? (
        <div data-testid="loader" className={styles.loadingContainer}>
          <Loader />
        </div>
      ) : (
        <button
          data-testid="moreRaces"
          className={styles.showMore}
          onClick={() => {
            logAmplitudeEvent(RACING_SHOW_MORE_CLICKED, {
              Module: isConsensus ? "consensus_picks" : "upcoming_races",
              "Loaded Races Count": races.length,
            });
            fetchNextPage();
          }}
          type="button"
        >
          Show More Races
          <ArrowsChevronDown color={fd.colors.coreWhite} />
        </button>
      )}
    </div>
  );
};

export default RaceList;
